import React from "react";

export interface InputLabelProps {
  name: string;
  label?: string;
  required?: boolean;
}

export const InputLabel = ({ name, label, required }: InputLabelProps): JSX.Element | null => {
  if (!label) return null;
  return (
    <label className="block text-sm font-medium mb-1 truncate" htmlFor={name}>
      {label} {required && <span className="text-rose-500">*</span>}
    </label>
  );
};
